import React, { useEffect, useState, useContext } from "react";
import { graphql } from "gatsby";
import Layout from "~/components/layout";
import BannerComponent from "../../components/banner";
import AnounceComponent from "../../components/anounce";
import SubAnounceComponent from "../../components/subanounce";
import styled from "styled-components";
import ContactComponent from "../../components/contact-component";
import Fade from 'react-reveal/Fade';
import * as Scroll from "react-scroll";
import AppContext from '../../context/play-url'
import SEO from "~/components/seo";

let Element = Scroll.Element;
const scroller = Scroll.scroller;

const WrapperContent = styled.div`
  position: relative;
  background-size: cover;
  background-attachment: fixed;
  background-position: 50%;
  height: 100%;
`;

const RegisterPage = ({ data }) => {
  const [isiFrame, setIsiFrame] = useState(false);
  const [urlIframe, setUrlIframe] = useState('');
  const pageName = "slotxo";
  const textBtn = "สมัครสมาชิก"
  const valueKey = "/register"
  const bannerList = data.datoCmsSlotxo.banner;
  const anounce = data.datoCmsAnounceSlider.anounceText;
  const subAnounce = {
    header: data.datoCmsRegister.contactHeader,
    content: data.datoCmsRegister.contactContent,
  }
  const contactDetail = data.datoCmsRegister.contactDetail
    .sort((a, b) => b.providerName.localeCompare(a.providerName === 'slotxo'));

  const { isiFrames, iframeUrl } = useContext(AppContext)

  useEffect(() => {
    scroller.scrollTo("myScrollToElement", {
      offset: 10,
      duration: 10,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  }, [])

  return (
    <Layout pageName={pageName}>
      <SEO lang="th" />
      <Fade bottom>
        <BannerComponent bannerList={bannerList} pageName={pageName} />
      </Fade>
      <WrapperContent className="w-full lg:container mx-auto">
        <Fade bottom>
          <Element name="myScrollToElement">
            <AnounceComponent anounce={anounce} pageName={pageName} />
          </Element>
        </Fade>
        <Fade bottom>
          <SubAnounceComponent subAnounce={subAnounce} pageName={pageName} />
        </Fade>
        <ContactComponent
          data={contactDetail}
          pageName={pageName}
          textBtn={textBtn}
          isiFrame={iframeUrl}
          setIsiFrame={setIsiFrame}
          setUrlIframe={setUrlIframe}
          valueKey={valueKey}
          />
      </WrapperContent>
      {!!iframeUrl && (
        <iframe className="w-full" src={iframeUrl} height="1080"></iframe>
      )}
    </Layout>
  );
};

export const query = graphql`
  query SlotxoRegisterPageTemplate {
    datoCmsSlotxo {
      banner {
        url(imgixParams: {auto: "format", q: 90})
      }
    }
    datoCmsAnounceSlider {
      anounceText
    }
    datoCmsRegister {
      contactHeader
      contactContent
      contactDetail {
        title
        link
        providerName
        providerLogo {
          url
        }
      }
    }
  }
`;

export default RegisterPage;
